function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d3dbe6;}.b{fill:#f8fafd;}.c{fill:none;}.d,.e{stroke:none;}.e{fill:#d3dbe6;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-421 -539)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 18,
  height: 18,
  rx: 3,
  transform: "translate(421 539)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M12.3,1.928a1.8,1.8,0,0,1,1.441,2.883l-.721.721L11.929,4.439,10.5,3.009l.721-.721a1.794,1.794,0,0,1,1.081-.36ZM3.291,10.216l-.721,3.243,3.243-.721,6.667-6.667L9.958,3.55Zm7.338-4.194L5.584,11.067l-.621-.621L10.008,5.4l.621.621Z",
  transform: "translate(0.479 1.396)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 1.869,
  height: 7.476,
  transform: "translate(10.139 6.289) rotate(45)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 7.476,
  height: 1.2,
  rx: 0.6,
  transform: "translate(6.123 6.949) rotate(45)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 14.448,
  height: 1.4,
  rx: 0.7,
  transform: "translate(4.392 3.363) rotate(45)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(4.499 14.856) rotate(-135)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M1,0,2,1.707H0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M 1 -3.099441528320312e-06 L 2 1.706776976585388 L 0 1.706776976585388 L 1 -3.099441528320312e-06 Z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M0,0H1.127A2.387,2.387,0,0,1,.664.9.7.7,0,0,1,0,1.01Z",
  transform: "translate(3.977 13.316) rotate(45)"
});

var SvgNoEdit = function SvgNoEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noEdit.9e34ef11.svg";
export { ForwardRef as ReactComponent };